module.exports = __webpack_public_path__ + "img/ic_menu_home.cb6741a3.svg";